(function() {
  define('tlhComponentsEditableContent',['jquery', 'angular', 'froala', 'froalaLangFr', 'froalaAlign', 'froalaCharCounter', 'froalaCodeBeautifier', 'froalaCodeView', 'froalaColors', 'froalaDraggable', 'froalaEmoticons', 'froalaEntities', 'froalaFile', 'froalaFontFamily', 'froalaFontSize', 'froalaForms', 'froalaFullscreen', 'froalaImage', 'froalaImageManager', 'froalaInlineStyle', 'froalaLineBreaker', 'froalaLink', 'froalaLists', 'froalaParagraphFormat', 'froalaParagraphStyle', 'froalaQuickInsert', 'froalaQuote', 'froalaSave', 'froalaTable', 'froalaUrl', 'froalaVideo'], function($) {
    'use strict';
    return angular.module('tlhComponentsEditableContent', []).component('tlhEditableContent', {
      require: {
        ngModel: 'ngModel'
      },
      template: '<div class="tlh-editable-content"></div>',
      bindings: {
        openEditor: '<',
        editorConfig: '<',
        editorEvents: '<',
        imagesMaxWidth: '@'
      },
      controller: [
        '$element', '$scope', 'TlhFroalaService', 'TlhImageService', 'TlhNotificationService', function($element, $scope, TlhFroalaService, TlhImageService, TlhNotificationService) {
          var configEditor, handleContentChanged, handleImagePaste, handleImageUpload, handleOpenLinkPopup, readInput, renderInput, setEditorEvents, vm;
          vm = this;
          vm.$onInit = function() {
            vm.ngModel.$render = renderInput;
            return configEditor();
          };
          readInput = function(value) {
            return vm.ngModel.$setViewValue(value);
          };
          renderInput = function() {
            var editor, value;
            value = vm.ngModel.$viewValue || '';
            editor = $element.find('.tlh-editable-content');
            if ($(editor).data('froala.editor')) {
              return $(editor).froalaEditor('html.set', value);
            } else {
              return editor.html(value);
            }
          };
          handleContentChanged = function(e, editor) {
            return $scope.$apply(function() {
              return readInput(editor.html.get());
            });
          };
          handleImageUpload = function(e, editor, images) {
            TlhNotificationService.info({
              message: 'Importation de l\'image en cours...',
              delay: false
            });
            TlhImageService.resizeImageFile(images[0], vm.imagesMaxWidth || 1000).then(function(result) {
              editor.image.insert(result.dataUrl, true, {
                'filename': result.filename,
                'mimeType': result.mimeType
              });
              return TlhNotificationService.success({
                message: 'Importation terminée',
                replaceMessage: true
              });
            })["catch"](function(error) {
              console.error(error);
              return TlhNotificationService.warning({
                message: 'Une erreur s\'est produite pendant l\'importation de l\'image, veuillez réessayer.',
                replaceMessage: true
              });
            });
            return false;
          };
          handleImagePaste = function(e, editor, images) {
            return false;
          };
          handleOpenLinkPopup = function(e, editor) {
            var target, url;
            url = document.getElementById('fr-link-insert-layer-url-1');
            target = document.getElementById('fr-link-target-1');
            if (!url.value) {
              return target.checked = true;
            }
          };
          configEditor = function() {
            var config;
            config = vm.editorConfig || {};
            if (!vm.openEditor) {
              config.initOnClick = true;
            }
            TlhFroalaService.completeConfigWithDefaultValues(config);
            return TlhFroalaService.completeConfigWithServerValues(config).then(function(result) {
              var editor;
              editor = $($element.find('.tlh-editable-content')).froalaEditor(result);
              return setEditorEvents(editor);
            });
          };
          setEditorEvents = function(editor) {
            var events, key, _i, _len, _ref, _results;
            events = vm.editorEvents || [];
            if (events['froalaEditor.contentChanged'] == null) {
              events['froalaEditor.contentChanged'] = handleContentChanged;
            }
            if (events['froalaEditor.image.beforeUpload'] == null) {
              events['froalaEditor.image.beforeUpload'] = handleImageUpload;
            }
            if (events['froalaEditor.image.beforePasteUpload'] == null) {
              events['froalaEditor.image.beforePasteUpload'] = handleImagePaste;
            }
            if (events['froalaEditor.popups.show.link.insert'] == null) {
              events['froalaEditor.popups.show.link.insert'] = handleOpenLinkPopup;
            }
            _ref = Object.keys(events);
            _results = [];
            for (_i = 0, _len = _ref.length; _i < _len; _i++) {
              key = _ref[_i];
              _results.push(editor.on(key, events[key]));
            }
            return _results;
          };
        }
      ]
    });
  });

}).call(this);

//# sourceMappingURL=editableContent.js.map
;
